<button
  type="button"
  class="stb-btn"
  [disabled]="disable"
  [class.stb-btn--active]="active"
  (click)="clickEvent($event)"
>
  <mat-icon class="stb-btn__icon">{{ matIcon }}</mat-icon>
  <span class="stb-btn__value">{{ value }}</span>
  <span class="stb-btn__label">{{ label }}</span>
</button>
